<script lang="ts">
  import { onMount } from 'svelte';
  import StatusBadge from '../../components/ui/StatusBadge.svelte';
  import { getAppContext } from '../context.js';

  const { platform } = getAppContext();
  let online = $state(platform.isOnline);

  onMount(() => platform.subscribeOnline((next) => {
    online = next;
  }));
</script>

{#if !online}
  <div
    class="fixed inset-x-0 top-0 z-[70] border-b border-[#d4a574] bg-[#f5e6c8] px-safe-x py-2 pt-safe-top text-center text-sm text-[#7c4a03]"
    role="status"
    aria-live="polite"
    data-testid="offline-status"
  >
    <StatusBadge variant="warning" label="Offline" />
    <span class="ml-2">You're offline. Texas 42 works without a connection.</span>
  </div>
{/if}
